import { t } from "i18next";
import { FollowUpType } from "../models/session";

export const followUpOptions = [
    { value: FollowUpType.ONSITE, label: t("FOLLOWUP_ONSITE") },
    { value: FollowUpType.ASSISTED, label: t("FOLLOWUP_ASSISTED") },
    { value: FollowUpType.ONLINE, label: t("GENERAL_ONLINE") },
];